import Vue from 'vue'
import Router from 'vue-router'

import { getAuthToken } from "@/axios/user";
import { loginBaseUrl, mainDomain } from '@/utils/config.js';
import { getCommonParam } from "@/axios/common";

// 先保存router原型对象的push
let origin = Router.prototype.push
//第一个参数：告诉push方法往哪里跳转，并传递哪些参数
Router.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        //js中的每个函数都有call和apply方法，唯一区别就是call传参用逗号隔开，apply使用数组，相同点都可以调用函数一次
        origin.call(this, location, resolve, reject)
    } else {
        origin.call(this, location, () => { }, () => { })
    }
}
Router.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        //js中的每个函数都有call和apply方法，唯一区别就是call传参用逗号隔开，apply使用数组，相同点都可以调用函数一次
        origin.call(this, location, resolve, reject)
    } else {
        origin.call(this, location, () => { }, () => { })
    }
}

const routes = [
    {
        path: '/rich',
        name: 'RichText',
        component: () => import('./views/richText/index.vue'),
        meta: { title: "星鹤国学" },
    },
  {
    path: '/moment',
    name: 'MomentInfo',
    component: () => import('./views/moment/info.vue'),
    meta: { title: "宠源源" },
  },
    {
        path: '/share',
        name: 'Share',
        component: () => import('./views/share/index.vue'),
        meta: { title: "宠源源" },
    },
    {
        path: '*',
        redirect: '/',
        name: ''
    }
]

const router = new Router({
    mode: "hash",
    routes
})

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title;
    window.scroll(0, 0);
    if (process.env.NODE_ENV === "production") {
        if (to.path.indexOf('wx') != -1 && !localStorage.getItem("token")) { //要判断下token为空
            var currentUrl = window.location.href
            if (to.query.authCode) {
                getAuthToken({ code: to.query.authCode }).then(res => {
                    if (res.code == 0) {
                        localStorage.setItem("token", res.data.token);
                        next();
                    }
                });
            } else {
                window.location.href = loginBaseUrl + '?backUrl=' + currentUrl;
            }
        } else {
            next();
        }
    } else {
        next();
    }

});

Vue.use(Router)

export default router
